/* Polsk katalog for locale-vat-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'vat.term': 'Okres VAT',
  'vat.termHelp': 'Okres VAT to okres, za który rozliczasz podatek od wartości dodanej. Większość firm rozlicza się co dwa miesiące - 6 okresów w roku. Za każdy okres sumuje się VAT należny i naliczony, a różnicę płaci się państwu lub otrzymuje zwrot.',
  'vat.termShort': 'okres',
  'vat.deadline': 'TERMIN',
  'vat.amountHelp': 'VAT do zapłaty oznacza zobowiązanie wobec państwa, ponieważ VAT należny był wyższy niż naliczony. VAT do zwrotu oznacza, że odzyskujesz pieniądze, ponieważ VAT zapłacony przy zakupach był wyższy niż VAT pobrany przy sprzedaży.',
  'vat.openReturn': 'Otwórz deklarację',
  'vat.sortHelp': 'Okresy są posortowane według statusu: „Wymaga działania” trzeba złożyć teraz, „Nadchodzące” to przyszłe okresy, a „Wcześniejsze” są już złożone lub opłacone.',
  'vat.noTerms': 'Brak okresów VAT',
  'vat.incompleteBasisTitle': 'Podstawa VAT jest niekompletna',
  'vat.incompleteBasisText': 'MVA-melding nie jest prezentowana jako kompletna, ponieważ pokrycie dziennika nie zostało udokumentowane. Obliczenia na podstawie dokumentów można nadal wykorzystywać diagnostycznie, ale nie jako pełną podstawę księgową.',
  'vat.needsAction': 'Wymaga działania',
  'vat.upcoming': 'Nadchodzące',
  'vat.earlier': 'Wcześniejsze',
  'vat.toPay': 'VAT do zapłaty',
  'vat.toPayHelp': 'Łączny zaległy VAT, gdy VAT należny jest wyższy niż naliczony.',
  'vat.paidIn': 'Wpłacono',
  'vat.paidInHelp': 'Płatności VAT zarejestrowane przez ciebie dla okresów w Plumme.',
  'vat.refunded': 'Zwrócono',
  'vat.refundedHelp': 'Zwroty VAT zarejestrowane przez ciebie dla okresów w Plumme.',
  'vat.perTerm': 'Na okres',
  'vat.returnStatus': 'Status MVA-melding',
  'vat.period': 'Okres',
  'vat.due': 'Termin',
  'vat.calculated': 'Obliczone rozliczenie',
  'vat.settlement': 'Rozliczenie',
  'vat.cancelPayment': 'Anuluj płatność',
  'vat.date': 'Data',
  'vat.amount': 'Kwota',
  'vat.reference': 'Referencja',
  'vat.referencePh': 'Np. bankowość internetowa, OCR',
  'vat.payments': 'Płatności',
  'vat.paymentsHelp': 'Przegląd płatności zarejestrowanych dla tego okresu VAT.',
  'vat.noPayments': 'Brak zarejestrowanych płatności',
  'vat.fromAccount': 'Z konta',
  'vat.edit': 'Edytuj',
  'vat.cancel': 'Anuluj',
  'vat.cancelPaymentTitle': 'Anulować płatność?',
  'vat.cancelPaymentConfirm': 'Tak, anuluj płatność',
  'vat.backToTerms': 'Powrót do okresów',
  'vat.importedBasisTitle': 'Zaimportowano z innego systemu księgowego',
  'vat.importedBasisHelp': 'Dane zostały zaimportowane jako podstawa. Możesz utworzyć, złożyć i w razie potrzeby anulować MVA-melding w zwykłym procesie.',
  'vat.outputVat': 'VAT należny',
  'vat.outputVatHelp': 'VAT pobrany przez ciebie od sprzedaży w okresie.',
  'vat.inputVat': 'VAT naliczony',
  'vat.inputVatHelp': 'VAT podlegający odliczeniu, zapłacony przy zakupach w okresie.',
  'vat.netVat': 'VAT netto',
  'vat.netHelp': 'VAT należny minus naliczony. Kwota dodatnia jest do zapłaty, kwota ujemna do zwrotu.',
  'vat.checkStatus': 'Sprawdź status',
  'vat.checkStatusHelp': 'Pokazuje status MVA-melding zapisany w Plumme. Automatyczny status z Altinn lub Skatteetaten nie jest jeszcze podłączony w tym obszarze Plumme.',
  'vat.seePayment': 'Zobacz płatność',
  'vat.seePaymentHelp': 'Zobacz płatności zarejestrowane dla tego okresu VAT — datę, konto, kwotę i referencję.',
  'vat.codeOverview': 'Przegląd kodów do złożenia',
  'vat.codeOverviewHelp': 'MVA-melding składa się ze standardowych kodów VAT Skatteetaten. Każdy kod obejmuje określony rodzaj sprzedaży lub zakupu. Podstawą jest kwota bez VAT. Przy odwrotnym obciążeniu pokazywany jest zarówno VAT należny, jak i naliczony, nawet gdy kwota netto wynosi 0. Stuknij kod, aby zobaczyć, co do niego należy.',
  'vat.codeTapHint': 'Stuknij kod, aby zobaczyć, co do niego należy.',
  'vat.code': 'Kod',
  'vat.description': 'Opis',
  'vat.basis': 'Podstawa',
  'vat.rate': 'Stawka',
  'vat.vat': 'VAT',
  'vat.calculatedFrom': 'Obliczono na podstawie danych zarejestrowanych w aplikacji',
  'vat.delete': 'Usuń',
  'vat.annulCustoms': 'Anuluj',
  'vat.annulled': 'Anulowano',
  'vat.showAnnulledCustoms': 'Pokaż anulowane',
  'vat.showActiveCustoms': 'Pokaż aktywne',
  'vat.customsAnnulled': 'Zgłoszenie celne anulowane',
  'vat.customsAnnulFailed': 'Nie udało się anulować zgłoszenia celnego.',
  'vat.registerCustoms': 'Zarejestruj zgłoszenie celne',
  'vat.customsHelp': 'Wprowadź zgłoszenie celne dla towarów sprowadzonych z zagranicy. Plumme oblicza VAT z tytułu importu na podstawie wartości statystycznej i wpisuje go pod właściwym kodem w deklaracji.',
  'vat.flowHelp': 'Sprawdź dane z zaksięgowanych dowodów księgowych. Plumme nie może wysłać MVA-melding: składasz ją w serwisie Skatteetaten, a następnie oznaczasz tutaj okres jako złożony poza Plumme. Wtedy możesz zarejestrować płatność. Status złożenia można usunąć, jeśli został ustawiony przez pomyłkę.',
  'vat.filing.statusFiled': 'Złożono poza Plumme',
  'vat.filing.statusFiledPaid': 'Złożono poza Plumme i opłacono',
  'vat.filing.statusNotFiled': 'Nieoznaczona jako złożona',
  'vat.filing.reviewFigures': 'Sprawdź dane',
  'vat.filing.reviewedToast': 'Dane zostały sprawdzone. Złóż MVA-melding w Skatteetaten.',
  'vat.filing.markOutside': 'Oznacz jako złożoną poza Plumme',
  'vat.filing.clearStatus': 'Usuń status złożenia',
  'vat.filing.dialogTitle': 'Złóż MVA-melding w Skatteetaten',
  'vat.filing.cannotSend': 'Plumme nie może wysłać ani podpisać MVA-melding. Składasz ją samodzielnie w Skatteetaten, a potem oznaczasz tutaj okres jako złożony.',
  'vat.filing.step1': 'Otwórz MVA-melding w serwisie Skatteetaten i wprowadź dane za ten okres z Plumme.',
  'vat.filing.step2': 'Wyślij i podpisz deklarację w serwisie oraz zachowaj potwierdzenie.',
  'vat.filing.step3': 'Oznacz tutaj okres jako złożony poza Plumme. Wtedy możesz zarejestrować płatność, a okres będzie liczony jako złożony przy zamknięciu roku.',
  'vat.filing.termNotEnded': 'Okres jeszcze się nie zakończył. MVA-melding można złożyć dopiero po zakończeniu okresu.',
  'vat.filing.filedDate': 'Data złożenia',
  'vat.filing.reference': 'Referencja (opcjonalnie)',
  'vat.filing.referencePh': 'Na przykład numer referencyjny z potwierdzenia od Skatteetaten',
  'vat.filing.comment': 'Komentarz (opcjonalnie)',
  'vat.filing.lockNote': 'Po oznaczeniu okresu jako złożonego dowody księgowe w tym okresie zostają zablokowane. Zmiany trzeba wtedy wprowadzać jako korektę.',
  'vat.filing.clearText': 'Okres będzie wtedy widoczny w Plumme jako niezłożony, a dowody księgowe w okresie zostaną odblokowane. Zmiana jest rejestrowana z informacją, kto i kiedy ją wprowadził. Status w Skatteetaten się nie zmienia.',
  'vat.filing.clearReason': 'Uzasadnienie (opcjonalnie)',
  'vat.filing.markedToast': 'Okres został oznaczony jako złożony poza Plumme',
  'vat.filing.clearedToast': 'Usunięto status złożenia',
  'vat.filing.failed': 'Nie udało się zaktualizować statusu VAT.',
  'vat.filing.payAfterFiled': 'Dostępne po złożeniu MVA-melding w Skatteetaten i oznaczeniu jej tutaj jako złożonej.',
  'vat.filing.markedOn': 'Oznaczono w Plumme',
  'vat.filing.referenceLabel': 'Referencja',
  'vat.filing.commentLabel': 'Komentarz',
  'vat.filing.statusNote': 'Plumme nie pobiera statusu ze Skatteetaten. Status widoczny tutaj to ten oznaczony w Plumme.',
  'vat.addComment': 'Dodaj komentarz',
  'vat.customs': 'Zgłoszenie celne',
  'vat.correctCustoms': 'Skoryguj zgłoszenie celne',
  'vat.saveCustoms': 'Zapisz zgłoszenie celne',
  'vat.fetchFromAltinn': 'Pobierz z Altinn',
  'vat.fetchFromAltinnHelp': 'Automatycznie uzupełnij odniesienie i wartość celną na podstawie złożonych zgłoszeń.',
  'vat.declarationRef': 'Numer zgłoszenia',
  'vat.declarationRefPh': 'Numer od Tolletaten',
  'vat.statisticalValue': 'Wartość statystyczna',
  'vat.vatCode': 'Kod VAT',
  'vat.attachments': 'Załączniki / ślad importu',
  'vat.uploadAttachment': 'Prześlij załącznik',
  'vat.attachmentHelp': 'Opcjonalne, ale zalecane dla ścieżki audytu i późniejszej obsługi importu.',
  'vat.customsBasis': 'Wartość celna',
  'vat.calculatedVat': 'Obliczony VAT',
  'vat.deductible': 'Prawo do odliczenia',
  'vat.settlementDate': 'Data rozliczenia',
  'vat.settlementType': 'Rodzaj rozliczenia',
  'vat.useDueDate': 'Termin płatności',
  'vat.useDueDateHelp': 'Ustaw datę rozliczenia na termin płatności MVA-melding',
  'vat.addSurcharges': 'Dodaj odsetki/opłaty',
  'vat.surcharges': 'Odsetki i opłaty',
  'vat.removeSurcharges': 'Usuń',
  'vat.lateInterest': 'Odsetki za zwłokę',
  'vat.lateInterestHelp': 'Księgowane jako koszt odsetek na 8150',
  'vat.penaltyFee': 'Opłata lub grzywna przymuszająca',
  'vat.penaltyFeeHelp': 'Księgowane na 7799 i niepodlegające odliczeniu',
  'vat.surchargeTotal': 'Obciąża rachunek',
  'vat.surchargeNote': 'Odsetki i opłaty nie są podatkiem VAT. Są ujmowane w kosztach i obciążają rachunek, ale nie zmieniają rozliczenia VAT za okres.',
  'vat.kid': 'KID',
  'vat.payTitle': 'Zapłać VAT do Skatteetaten',
  'vat.payHelp': 'Numer rachunku i KID są podawane przez Skatteetaten po rozpatrzeniu deklaracji. Płatność bezpośrednio z banku nie jest jeszcze podłączona, dlatego na razie płatność rejestruje się w Plumme.',
  'vat.awaitingAuthority': 'Podaje Skatteetaten',
  'vat.pay': 'Zapłać',
  'vat.kidHelp': 'KID z MVA-melding',
  'vat.authorityAccount': 'Numer rachunku Skatteetaten',
  'vat.authorityAccountHelp': 'Numer rachunku Skatteetaten',
  'vat.notRegistered': 'Firma nie jest ustawiona jako zarejestrowana do VAT',
  'vat.view': 'Widok',
  'vat.viewHelp': 'Przełączaj między „Okresami” — karta dla każdego okresu VAT ze statusem i terminem — a „Przeglądem”, który podsumowuje, ile jesteś winien, ile zapłaciłeś i ile masz do zwrotu we wszystkich okresach.',
  'vat.viewTerms': 'Okresy',
  'vat.viewOverview': 'Przegląd',
  'vat.filing.notFiled': 'Nie złożono',
  'vat.filing.upcomingStatus': 'Nadchodzący',
  'vat.filing.importedArchive': 'Zaimportowane archiwum',
  'vat.vatReceivable': 'VAT do zwrotu',
  'vat.vatToPay': 'VAT do zapłaty',
  'vat.noVat': 'Brak VAT',
  'vat.receivableShort': 'Do zwrotu',
  'vat.remainingToPay': 'Pozostało do zapłaty',
  'vat.termLabel': '{n}. okres {year}',
  'vat.noTermsHelp': 'Gdy firma zostanie zarejestrowana do VAT, Plumme pokaże tutaj okresy, terminy i obliczony VAT.',
  'vat.youOwe': 'Jesteś winien',
  'vat.youAreOwed': 'Masz do zwrotu',
  'vat.noVatToSettle': 'Brak VAT do rozliczenia',
  'vat.refund': 'Zwrot',
  'vat.paymentNoun': 'Płatność',
  'vat.settlementNoun': 'Rozliczenie',
  'vat.acctBankDeposit': 'Środki na rachunku bankowym',
  'vat.acctTaxDeductionAccount': 'Rachunek zaliczek podatkowych',
  'vat.acctCash': 'Gotówka',
  'vat.accountFallback': 'Konto {code}',
  'vat.settlementFullyRegistered': 'Zarejestrowano w całości',
  'vat.settlementPartiallyRegistered': 'Zarejestrowano częściowo',
  'vat.settlementNotRegistered': 'Nie zarejestrowano',
  'vat.editRefund': 'Edytuj zwrot',
  'vat.editPayment': 'Edytuj płatność',
  'vat.receivedOn': 'Otrzymano na',
  'vat.paidFrom': 'Zapłacono z',
  'vat.noPaymentsHelp': 'Gdy zarejestrujesz płatność lub zwrot za okres, pojawi się tutaj.',
  'vat.addRefund': 'Dodaj zwrot',
  'vat.addPayment': 'Dodaj płatność',
  'vat.cancelPaymentConfirmPrefix': 'Czy chcesz anulować {kind} na kwotę',
  'vat.cancelPaymentConfirmDate': ' z dnia {date}',
  'vat.cancelPaymentConfirmSuffix': '? Kwota zostanie usunięta z okresu VAT i nie będzie można jej przywrócić.',
  'vat.overpaid': 'Nadpłacono',
  'vat.overrefunded': 'Zwrócono za dużo',
  'vat.remainingToReceive': 'Pozostało do otrzymania',
  'vat.registerSettlement': 'Zarejestruj rozliczenie',
  'vat.registerPayment': 'Zarejestruj płatność',
  'vat.registerRefund': 'Zarejestruj zwrot',
  'vat.inYourFavor': 'na Twoją korzyść',
  'vat.toTaxAuthority': 'do Skatteetaten',
  'vat.receivedBack': 'Otrzymano zwrot',
  'vat.archiveCannotSettle': 'Zaimportowanej historii nie można rozliczyć jako nowego okresu Plumme.',
  'vat.noVatToSettleForTerm': 'W tym okresie nie ma VAT do rozliczenia.',
  'vat.sourceImported': 'Zaimportowano',
  'vat.sourceManual': 'Zarejestrowano ręcznie',
  'vat.registerVatRefund': 'Zarejestruj zwrot VAT',
  'vat.registerVatPayment': 'Zarejestruj płatność VAT',
  'vat.saveRefund': 'Zapisz zwrot',
  'vat.savePayment': 'Zapisz płatność',
  'vat.remainingHint': 'Pozostało {amount}',
  'vat.notRegisteredHelp': 'Gdy firma zostanie ustawiona w ustawieniach jako zarejestrowana do VAT, Plumme pokaże tutaj okresy VAT, przegląd kodów i rozliczenie.',
  'vat.reviewReadyToast': 'MVA-melding jest gotowa do sprawdzenia',
  'vat.customsAltinnNotConnected': 'Import zgłoszeń celnych z Altinn nie jest jeszcze podłączony.',
  'vat.selectAttachmentToUpload': 'Wybierz załącznik do przesłania',
  'vat.customsDefaultDescription': 'Zgłoszenie celne',
  'vat.customsDateTermHint': 'Data musi mieścić się w okresie {period}.',
  'vat.customs81': '25% z prawem do odliczenia',
  'vat.customs82': '25% bez prawa do odliczenia',
  'vat.customs83': '15% z prawem do odliczenia',
  'vat.customs84': '15% bez prawa do odliczenia',
  'vat.customs85': '0% przywóz',
  'vat.customsSaved': 'Zgłoszenie celne zapisane',
  'vat.customsSaveFailed': 'Nie udało się zapisać zgłoszenia celnego.',
  'vat.customsDeleted': 'Zgłoszenie celne usunięte',
  'vat.customsDeleteFailed': 'Nie udało się usunąć zgłoszenia celnego.',
  'vat.refundSaved': 'Zwrot zapisany',
  'vat.paymentSaved': 'Płatność zapisana',
  'vat.paymentSaveFailed': 'Nie udało się zapisać płatności.',
  'vat.refundCancelled': 'Zwrot anulowany',
  'vat.paymentCancelled': 'Płatność anulowana',
  'vat.paymentCancelFailed': 'Nie udało się anulować płatności.',
  'vat.supplierSearch': 'Wyszukaj lub dodaj dostawcę...',
  'vat.supplierClose': 'Zamknij wybór dostawcy',
  'vat.supplierNone': 'Nie znaleziono dostawców.',
  'vat.supplierNew': 'Nowy dostawca',
  'vat.supplierName': 'Nazwa',
  'vat.supplierOrg': 'Nr org.',
  'vat.supplierEmail': 'E-mail',
  'vat.supplierPhone': 'Telefon',
  'vat.customsPostingExplanation': 'Użyj kwot ze zgłoszenia celnego. VAT bez prawa do odliczenia trzeba zaksięgować na właściwym koncie kosztów lub aktywów.',
  'vat.nonDeductibleAccount': 'Konto dla VAT bez prawa do odliczenia',
  'vat.nonDeductibleAccountHelp': 'Wybierz to samo konto kosztów lub aktywów, którego dotyczy nabycie. Konto trzeba podać przed zaksięgowaniem.',
  'voucherList.titleHelp': 'Dowód księgowy to dokumentacja stojąca za księgowaniem: faktura, paragon, inna sprzedaż, zgłoszenie celne lub księgowanie swobodne. Tutaj widzisz dowody pobrane z backendu dla wybranego roku obrotowego.',
  'voucherList.backToTrialBalance': 'Wróć do zestawienia obrotów i sald',
  'voucherList.backToIncomeStatement': 'Wróć do rachunku zysków i strat',
  'voucherList.accountBadge': 'Konto {number} · {name}',
  'voucherList.vatCodeBadge': 'Kod VAT {code}',
  'voucherList.viewOptions': 'Opcje widoku',
  'voucherList.noneForVatCode': 'Nie znaleziono dowodów dla kodu VAT {code} w wybranym okresie.',
  'voucherList.noneForAccount': 'Brak dowodów zaksięgowanych na {number} {name} w {year}.',
  'voucherList.noneMatchSearch': 'Żadne dowody nie pasują do wyszukiwania.',
  'voucherList.noneInView': 'Żadne dowody nie pasują do tego widoku.',
  'voucherList.ledgerLinesMissing': 'Dowodom brakuje pozycji księgowań z backendu.',
  'voucherList.debit': 'Wn',
  'voucherList.credit': 'Ma',
  'voucherList.colVoucher': 'Dowód',
  'voucherList.colNumber': 'Nr dowodu',
  'voucherList.colDate': 'Data',
  'voucherList.inlineVat': 'VAT',
  'voucherList.kindInvoice': 'Faktura',
  'voucherList.kindSupplier': 'Dostawca',
  'voucherList.kindCreditNote': 'Faktura korygująca',
  'voucherList.kindManual': 'Dowód ręczny',
  'voucherList.kindPurchase': 'Zakup',
  'voucherList.kindOtherSale': 'Inna sprzedaż',
  'voucherList.kindMileage': 'Ewidencja przebiegu',
  'voucherList.kindCustoms': 'Zgłoszenie celne',
  'voucherList.kindCustomsCorrection': 'Korekta okresu zgłoszenia celnego',
  'voucherList.kindBankPosting': 'Księgowanie bankowe',
  'voucherList.kindPayment': 'Płatność',
  'voucherList.kindPayroll': 'Płace',
  'voucherList.kindPayrollPayment': 'Wypłata wynagrodzeń',
  'voucherList.kindReversal': 'Storno',
  'voucherList.kindPublicFees': 'Opłaty publiczne',
  'voucherList.kindAssetDisposal': 'Rozchód środka trwałego',
  'voucherList.kindYearEnd': 'Zamknięcie roku',
  'voucherList.kindQuote': 'Oferta',
  'voucherList.kindOrderConfirmation': 'Potwierdzenie zamówienia',
  'voucherList.filterSales': 'Sprzedaż',
  'voucherList.filterSupplierInvoice': 'Faktura od dostawcy',
  'voucherList.filterFreePosting': 'Księgowanie swobodne',
  'voucherList.missingAttachment': 'Brak załącznika',
  'voucherList.hasAttachment': 'Z załącznikiem',
  'voucherList.unpaid': 'Nieopłacone',
  'voucherList.showAnnulled': 'Pokaż anulowane',
  'voucherList.hidePayments': 'Ukryj płatności',
  'voucherList.includeAnnulled': 'Uwzględnij anulowane',
  'vat.amountOnly': 'Tylko VAT',
  'voucherList.onlyAnnulled': 'Pokaż tylko anulowane',
  'voucherList.paid': 'Opłacone',
  'voucherList.partiallyPaid': 'Częściowo opłacone',
  'voucherList.annulled': 'Anulowane',
  'voucherList.attachmentLost': 'Dowód utracony',
  'voucherList.openInvoiceList': 'Zobacz na liście faktur',
  'voucherList.editSale': 'Edytuj sprzedaż',
  'voucherList.openInBank': 'Otwórz w banku',
  'voucherList.editPosting': 'Edytuj księgowanie',
  'voucherList.correctPosting': 'Skoryguj dowód',
  'voucherList.editMileage': 'Edytuj ewidencję przebiegu',
  'voucherList.openInVat': 'Otwórz w VAT',
  'voucherList.edit': 'Edytuj',
  'voucherList.purchaseNotFound': 'Nie znaleziono zakupu do edycji. Odśwież stronę i ponownie otwórz dowód.',
  'voucherList.saleNotFound': 'Nie znaleziono sprzedaży do edycji. Odśwież stronę i ponownie otwórz dowód.',
  'inboxStatus.alreadyBooked': 'Już zaksięgowano?',
  'inboxStatus.booked': 'Zaksięgowano',
  'inboxStatus.inTrash': 'W koszu',
  'inboxStatus.readyToBook': 'Gotowe do zaksięgowania',
  'inboxStatus.needsReview': 'Wymaga sprawdzenia',
  'inboxStatus.analysisFailed': 'Analiza nie powiodła się',
  'inboxStatus.analyzing': 'Analizowanie',
  'inboxStatus.awaitingAnalysis': 'Oczekuje na analizę',
  'inboxStatus.show': 'Pokaż',
  'inboxStatus.hide': 'Ukryj',
  'inboxStatus.dropReceipts': 'Upuść dokumenty tutaj',
  'inboxStatus.dropReceiptsHint': 'SuperPlumma odczyta, co się da',
  'inboxStatus.dropDocuments': 'Upuść dokumenty tutaj',
  'inboxStatus.dropDocumentsHint': 'Trafią do Dokumentacji',
  'inboxStatus.bookWithSuperPlumma': 'Zaksięguj z SuperPlumma',
  'inboxStatus.saving': 'Zapisywanie...',
  'purchaseFlow.stepReceipt': 'Dokument',
  'purchaseFlow.stepDetails': 'Szczegóły',
  'purchaseFlow.stepLines': 'Linie',
  'purchaseFlow.stepPreview': 'Podgląd',
  'purchaseFlow.typeRegular': 'Opłacony zakup',
  'purchaseFlow.typeInvoice': 'Faktura dostawcy',
  'purchaseFlow.typeDrafts': 'Szkice',
  'purchaseFlow.receivedReading': 'Dokument odebrany - SuperPlumma właśnie go odczytuje',
  'purchaseFlow.receivedReadingMany': 'Odebrane dokumenty: {count} - SuperPlumma właśnie je odczytuje',
  'purchaseFlow.prefilled': 'SuperPlumma wypełniła to, co dało się odczytać z dokumentu. Sprawdź przed zaksięgowaniem.',
  'purchaseFlow.amountReview': 'Nie udało się wiarygodnie wypełnić kwot i VAT. Sprawdź dokument i wpisz kwotę netto oraz właściwe traktowanie VAT dla każdej linii przed zaksięgowaniem.',
  'purchaseFlow.analysisFailed': 'Dokument został przesłany, ale analiza się nie powiodła.',
  'purchaseFlow.inboxResolveFailed': 'Księgowanie zostało zapisane, ale dokument nie został usunięty ze skrzynki odbiorczej. Oznacz go tam jako zaksięgowany.',
  'purchaseFlow.receiptFallbackName': 'Dokument',
});
